
<template>
  <div class="card">
    <div class="icon-container">
      <FontAwesomeIcon v-if="iconType === 'fa'" :icon="['fal', iconName]" class="fa-icon fa-6x"/>     
      <img v-else-if="(iconType === 'svg' && iconName === 'user-question')" :src="require('@/assets/user-question.svg')" width="80px" height="80px" alt="icon"/>
    </div>
    <div class="text-container">
      <h3 class="title">{{ title }}</h3>
      <p class="description">{{ description }}</p>
      <a :href="link" target="_blank">
        <button class="action-button">{{ buttonText }}</button>
      </a>
    </div>
  </div>
</template>

<script>

export default {
  name: "IconCard",
  props: {
    iconType: String,
    iconName: String,
    title: String,
    description: String,
    buttonText: String,
    link: String,
  },
};
</script>

<style lang="scss" scoped>

.card {
  background: var(--Greyscale-white, #FFF);
  border-radius: 4px;
  height: 250px;
  box-shadow: 1px 4px 12px 0 var(--Greyscale-font-grey-dark, #BFBFBF);
  display: flex;
  justify-content: center;
  flex-direction: row;
  margin: 5px;
  margin: 5px;
}

.icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  place-self: center;
  width: 40%;
  padding: 20px;
}

.text-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  text-align: start;
  width: 60%;
  padding: 20px 20px 20px 0;
}

.action-button {
  background-color: color(tertiary);
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
}

.action-button:hover {
  background-color: color(tertiary-dark);
}

.action-button:active {
  background-color: color(tertiary-darker);
}

@media (max-width: $bp_tablet) {
  .card {
    display: flex;
    flex-direction: column;
    height: 330px;
    place-self: center;
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .icon-container {
    width: 100%;
  }

  .text-container {
    width: 100%;
    height: auto;
    align-items: center;
    text-align: center;
    padding: 20px;
  }
}

@media (max-width: $bp_sm_tablet) {
  .card {
    width: 100%;
    height: auto;
  }
}

@media (max-width: $bp_mobile) {
  .icon-container {
    display: none;
  }
}

</style>
